// Browser downloads for generated files.
import { strToU8, zipSync } from 'fflate';
import type { CsvFile } from '@bda/shared';

export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const saveText = (text: string, fileName: string, type: string): void =>
  saveBlob(new Blob([text], { type }), fileName);

/** One CSV downloads directly; several are zipped (requirement 5.6, design 3.5). */
export function csvDownload(files: CsvFile[], baseName: string): { blob: Blob; fileName: string } {
  if (files.length === 1)
    return { blob: new Blob([files[0]!.content], { type: 'text/csv' }), fileName: `${baseName}.csv` };
  const zip = zipSync(Object.fromEntries(files.map((f) => [f.name, strToU8(f.content)])));
  return { blob: new Blob([zip as BlobPart], { type: 'application/zip' }), fileName: `${baseName}-csv.zip` };
}

export const safeName = (s: string): string => s.replace(/[^A-Za-z0-9_-]+/g, '_').replace(/^_+|_+$/g, '') || 'download';
